$(document).ready(function(){
  /*** Disable dynamic Shopify Content Until Store Launch ***/
  
  // Home Page
  $('#shopify-section-1570472352020 .collection-item').removeAttr("href").addClass('disabled');
});